/**
 * This is separate from the panel-config to avoid circular reference - the grid uses this for saved views
 */
export const RawTradeSummaryKey = 'raw-trade-summary-rtsrt' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
